/**
 * Returns a string with the class names separated by a space
 * @param classNames The class names to be concatenated
 * @returns A string with the class names separated by a space
 *
 * @example
 * cn('class1', 'class2', '', undefined, 'class3') // 'class1 class2 class3'
 */
export function cn(...classNames: (string | undefined)[]): string {
  return classNames.filter(Boolean).join(' ')
}

/**
 * Returns a type-safe array with the keys of an object
 */
export function getKeys<T extends object>(obj: T) {
  return Object.keys(obj) as Array<keyof T>
}
